import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

const statusClasses = {
  completed: "bg-green-100 text-green-700",
  missed: "bg-red-100 text-red-600",
  cancelled: "bg-gray-100 text-gray-700",
  expired: "bg-gray-100 text-gray-700",
};

import formatDuration from "@/utils/formatDuration";

const CallTable = ({ paginatedData }) => {
  if (paginatedData.length === 0) {
    return <div className="text-center text-gray-500 py-10">No calls found</div>;
  }

  return (
    <div className="w-full p-0 overflow-y-auto bg-white rounded-2xl">
      <div className="flex flex-col h-full">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse rounded-lg">
            <thead>
              <tr className="text-left text-xs font-semibold text-gray-700 bg-gray-100 sticky top-0 z-10">
                <th className="p-3">NAME</th>
                <th className="p-3">TYPE</th>
                <th className="p-3">MODE</th>
                <th className="p-3">DATE/TIME OF SUBMISSION</th>
                <th className="p-3">STATUS</th>
                <th className="p-3">DURATION</th>
                <th className="p-3">RATE/MIN<br />CHARGES</th>
                {/* <th className="p-3"></th> */}
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((call) => (
                <tr key={call.id} className="border-b border-gray-100 text-sm hover:bg-gray-50 transition">
                  <td className="flex items-center space-x-3 p-3">
                    {call.image ? (
                      <img src={call.image} alt={call.name} className="h-8 w-8 rounded-full object-cover border-2 border-orange-500" />
                    ) : (
                      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-orange-500 text-white font-semibold">
                        {call.name
                          .split(" ")
                          .map((word) => word[0])
                          .join("")
                          .toUpperCase()}
                      </div>
                    )}
                    <div>
                      <p className="font-semibold">{call.name}</p>
                      <p className="text-xs text-gray-400">{call.reference}</p>
                    </div>
                  </td>
                  <td className="p-3">{call.type}</td>
                  <td className="p-3 font-bold">{call.mode}</td>
                  <td className="p-3 whitespace-nowrap">
                    {call.date instanceof Date
                      ? `${moment(call.date).format('DD/MM/YY, h:mm A')}`
                      : call.date}
                  </td>
                  <td className="p-3">
                    {['missed', 'expired'].includes(call.status?.toLowerCase()) ? (
                      <span className="px-2 py-1 rounded-md text-xs font-semibold bg-red-100 text-red-600">Missed</span>
                    ) : call.status?.toLowerCase() === 'completed' ? (
                      <span className="px-2 py-1 rounded-md text-xs font-semibold bg-green-100 text-green-700">Completed</span>
                    ) : (
                      <span className="px-2 py-1 rounded-md text-xs font-semibold bg-gray-100 text-gray-700">{call.status?.charAt(0).toUpperCase() + call.status?.slice(1)}</span>
                    )}
                  </td>
                  <td className="p-3 font-bold">{formatDuration(call.duration)}</td>
                  <td className="p-3 font-bold">₹{call.rate || 0}</td>
                  {/* <td className="p-3 text-right">
                    <button className="rounded-full hover:bg-gray-200 p-1 transition" aria-label="More options">
                      <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="6" r="1.5" fill="#A3A3A3" /><circle cx="12" cy="12" r="1.5" fill="#A3A3A3" /><circle cx="12" cy="18" r="1.5" fill="#A3A3A3" /></svg>
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

CallTable.propTypes = {
  paginatedData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      reference: PropTypes.string,
      type: PropTypes.string,
      mode: PropTypes.string,
      date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      status: PropTypes.string,
      duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
};

export default CallTable;
